// 假期参数
import React from 'react'
import { connect } from 'react-redux'
import { nullDate, TDate } from '../../public/utility'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, addListItemsFromListItems, resetListValues, isListValuesChanged, cloneListItem } from '../../public/utility'

class HolidayParamDiv extends React.Component {
    state = {
        changedValues基本信息: {}
    }
    handlerConfirm = () => {
        const { changedValues基本信息, typesOfchangedValues基本信息 } = this.state
        const { onConfirm, onClose, initValues基本信息 } = this.props
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        onConfirm && onConfirm(changedValues基本信息, typesOfchangedValues基本信息, onClose)
    }

    handlerDelete = () => {
        const { onDelete, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () => {
            onDelete && onDelete()
            onClose && onClose()
        })
    }

    handlerClose = () => {
        const { changedValues基本信息 } = this.state
        const { onClose } = this.props
        if (!changedValues基本信息 || Object.keys(changedValues基本信息).length === 0) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '参数名称', required: true, minWidth: '95%' },
            { _radio: '输入方式', minWidth: '95%' },
            { _text: '输入选项', minWidth: '95%' },
        ]
    }

    canSave = () => {
        const { initValues基本信息 } = this.props
        const { changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && values.参数名称
    }

    render() {
        const { showBody: Body, initValues基本信息, onDelete } = this.props
        const { changedValues基本信息 = {} } = this.state
        const canSave = this.canSave()
        const bChanged = Object.keys(changedValues基本信息).length > 0
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => onDelete, handler: this.handlerDelete },
                    { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(HolidayParamDiv)